// extracted by mini-css-extract-plugin
module.exports = {"container":"Faq_container__1u7Ip","questionAnswer":"Faq_questionAnswer__3_59e","row":"Faq_row__p_X2r","question":"Faq_question___6SHq","answer":"Faq_answer__1qc4H"};